import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";

export interface TenantUser {
  userId: string;
  email: string;
  role: string;
}

/** GET /api/users — tenant users for the manual-task assignee picker (admin/marketing). */
export function useTenantUsers(search?: string) {
  return useQuery({
    queryKey: ["users", getActiveTenantId(), search ?? ""] as const,
    queryFn: () => httpClient<{ items: TenantUser[] }>(`/api/users${search ? `?search=${encodeURIComponent(search)}` : ""}`),
  });
}
